export enum WarningModalContext {
	EnterCsp = 'enter-csp',
	EnterCspfs = 'enter-csp-fs',
	ProductPricingConflict = 'product-pricing-conflict'
}
